import { EDITOR_TYPES } from 'reporting-data/tsTypes/editorTypes';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
export const WEIGHTED_PIPELINE_FORECAST_CONFIG = {
  name: 'Weighted Pipeline Forecast',
  config: {
    sort: [{
      property: 'hs_projected_amount_in_home_currency',
      order: 'DESC',
      metricType: 'SUM'
    }],
    filters: {
      teams: [],
      custom: [],
      owners: [],
      dateRange: {
        value: {
          endDate: '2024-12-31',
          rangeType: 'LAST_YEAR',
          startDate: '2024-01-01',
          entireCurrentUnit: true
        },
        property: 'closedate',
        useFiscalYear: false
      },
      filterGroups: [{
        filters: [{
          value: 'false',
          values: [],
          operator: 'EQ',
          property: 'hs_is_closed_lost'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'pipeline'
        }]
      }]
    },
    metrics: [{
      property: 'hs_projected_amount_in_home_currency',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'CRM_OBJECT',
    objectTypeId: '0-3',
    configType: 'AGGREGATION',
    dimensions: ['hubspot_team_id', 'dealstage']
  },
  chartType: 'BAR',
  customized: true,
  resolveType: 'CONFIG',
  displayParams: {
    stacked: true,
    showTotals: true,
    dataColumns: ['amount_in_home_currency', 'dealstage', 'hs_manual_forecast_category', 'hs_forecast_amount', 'hs_projected_amount', 'hs_projected_amount_in_home_currency', 'hubspot_team_id'],
    customSeries: [],
    salesAnalytics: {
      subAppKey: SUB_APPS.weightedPipelineForecast
    }
  },
  reportConfigs: {
    secondary: {
      filters: {
        teams: [],
        filterGroups: [{
          filters: [{
            value: 'currency',
            values: [],
            operator: 'EQ',
            property: 'hs_kpi_unit_type'
          }, {
            value: 'sales_quota',
            operator: 'EQ',
            property: 'hs_goal_type'
          }, {
            value: 'USD',
            operator: 'EQ',
            property: 'hs_goal_target_currency_code'
          }, {
            value: 0,
            operator: 'NEQ',
            property: 'hs_kpi_value'
          }, {
            values: ['teams'],
            operator: 'IN',
            property: 'hs_assignee_type'
          }, {
            values: ['default'],
            operator: 'IN',
            property: 'hs_pipeline_ids'
          }]
        }],
        owners: [],
        dateRange: {
          value: {
            date: null,
            endDate: '2024-12-31',
            rangeType: 'LAST_YEAR',
            startDate: '2024-01-01',
            rollingDays: null,
            rollingDates: null,
            entireCurrentUnit: true
          },
          property: 'hs_start_datetime',
          useFiscalYear: false
        }
      },
      metrics: [{
        property: 'hs_target_amount_in_home_currency',
        metricTypes: ['SUM'],
        percentiles: []
      }],
      dataType: 'CRM_OBJECT',
      configType: 'AGGREGATION',
      dimensions: ['hubspot_team_id'],
      processors: [],
      eventFunnel: null,
      objectTypeId: '0-74'
    }
  },
  visualization: {
    type: 'XY',
    style: {
      x: {
        left: {}
      },
      y: {
        bottom: {}
      },
      type: 'bar',
      colors: ['#fea58e', '#51d3d9', '#bda9ea', '#f5c78e', '#ea90b1', '#81c1fd', '#a4d398', '#c3705c', '#009ca2', '#8775b2', '#bb915b', '#b05c7d', '#468cc4', '#6b9a5b'],
      isMobile: false,
      dataLabels: false,
      showLegend: true,
      stackLabels: true,
      dataLabelFormat: 'Y'
    },
    layers: [{
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_projected_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        stack: 'DEFAULT_STACK',
        stacking: true
      },
      color: {
        field: 'dealstage'
      },
      dataset: 'primary'
    }, {
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_target_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        type: 'tick',
        marker: {
          lineColor: '#516f90',
          lineWidth: 2
        },
        dashStyle: 'shortDash'
      },
      color: {
        default: '#516f90'
      },
      dataset: 'secondary'
    }]
  },
  editors: [{
    type: EDITOR_TYPES.DIMENSION,
    properties: ['hubspot_team_id', 'hubspot_owner_id']
  }, {
    type: EDITOR_TYPES.BREAKDOWN,
    properties: ['dealstage']
  }, {
    type: EDITOR_TYPES.OVERTIME_TOTALS
  }]
};
export const WEIGHTED_FORECAST_CATEGORY_CONFIG = {
  name: 'Weighteted Forecast Category',
  config: {
    sort: [{
      property: 'hs_projected_amount_in_home_currency',
      order: 'DESC',
      metricType: 'SUM'
    }],
    filters: {
      teams: [],
      custom: [],
      owners: [],
      dateRange: {
        value: {
          endDate: '2024-12-31',
          rangeType: 'LAST_YEAR',
          startDate: '2024-01-01',
          entireCurrentUnit: true
        },
        property: 'closedate',
        useFiscalYear: false
      },
      filterGroups: [{
        filters: [{
          value: 'false',
          values: [],
          operator: 'EQ',
          property: 'hs_is_closed_lost'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'pipeline'
        }]
      }]
    },
    metrics: [{
      property: 'hs_projected_amount_in_home_currency',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'CRM_OBJECT',
    objectTypeId: '0-3',
    configType: 'AGGREGATION',
    dimensions: ['hubspot_team_id', 'hs_manual_forecast_category']
  },
  chartType: 'BAR',
  customized: true,
  resolveType: 'CONFIG',
  displayParams: {
    stacked: true,
    showTotals: true,
    dataColumns: ['amount_in_home_currency', 'dealstage', 'hs_manual_forecast_category', 'hs_forecast_amount', 'hs_projected_amount', 'hs_projected_amount_in_home_currency', 'hubspot_team_id'],
    customSeries: []
  },
  reportConfigs: {
    secondary: {
      filters: {
        teams: [],
        custom: [{
          value: 'currency',
          values: [],
          operator: 'EQ',
          property: 'hs_kpi_unit_type'
        }, {
          value: 'sales_quota',
          operator: 'EQ',
          property: 'hs_goal_type'
        }, {
          value: 'USD',
          operator: 'EQ',
          property: 'hs_goal_target_currency_code'
        }, {
          value: 0,
          operator: 'NEQ',
          property: 'hs_kpi_value'
        }, {
          values: ['teams'],
          operator: 'IN',
          property: 'hs_assignee_type'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'hs_pipeline_ids'
        }],
        owners: [],
        dateRange: {
          value: {
            date: null,
            endDate: '2024-12-31',
            rangeType: 'LAST_YEAR',
            startDate: '2024-01-01',
            rollingDays: null,
            rollingDates: null,
            entireCurrentUnit: true
          },
          property: 'hs_start_datetime',
          useFiscalYear: false
        }
      },
      metrics: [{
        property: 'hs_target_amount_in_home_currency',
        metricTypes: ['SUM'],
        percentiles: []
      }],
      dataType: 'CRM_OBJECT',
      configType: 'AGGREGATION',
      dimensions: ['hubspot_team_id'],
      processors: [],
      eventFunnel: null,
      objectTypeId: '0-74'
    }
  },
  visualization: {
    type: 'XY',
    style: {
      x: {
        left: {}
      },
      y: {
        bottom: {}
      },
      type: 'bar',
      colors: ['#fea58e', '#51d3d9', '#bda9ea', '#f5c78e', '#ea90b1', '#81c1fd', '#a4d398', '#c3705c', '#009ca2', '#8775b2', '#bb915b', '#b05c7d', '#468cc4', '#6b9a5b'],
      isMobile: false,
      dataLabels: false,
      showLegend: true,
      stackLabels: true,
      dataLabelFormat: 'Y'
    },
    layers: [{
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_projected_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        stack: 'DEFAULT_STACK',
        stacking: true
      },
      color: {
        field: 'hs_manual_forecast_category',
        defined: {
          CLOSED: '#ea90b1',
          COMMIT: '#f5c78e',
          PIPELINE: '#51d3d9',
          BEST_CASE: '#bda9ea',
          '@@MISSING@@': '#fea58e'
        }
      },
      dataset: 'primary'
    }, {
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_target_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        type: 'tick',
        marker: {
          lineColor: '#516f90',
          lineWidth: 2
        },
        dashStyle: 'shortDash'
      },
      color: {
        default: '#516f90'
      },
      dataset: 'secondary'
    }]
  },
  editors: [{
    type: EDITOR_TYPES.DIMENSION,
    properties: ['hubspot_team_id', 'hubspot_owner_id']
  }, {
    type: EDITOR_TYPES.BREAKDOWN,
    properties: ['hs_manual_forecast_category']
  }, {
    type: EDITOR_TYPES.OVERTIME_TOTALS
  }]
};
export const FORECAST_CATEGORY_CONFIG = {
  name: 'Forecast Category',
  config: {
    sort: [{
      property: 'amount_in_home_currency',
      order: 'DESC',
      metricType: 'SUM'
    }],
    filters: {
      teams: [],
      custom: [],
      owners: [],
      dateRange: {
        value: {
          endDate: '2024-12-31',
          rangeType: 'LAST_YEAR',
          startDate: '2024-01-01',
          entireCurrentUnit: true
        },
        property: 'closedate',
        useFiscalYear: false
      },
      filterGroups: [{
        filters: [{
          value: 'false',
          values: [],
          operator: 'EQ',
          property: 'hs_is_closed_lost'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'pipeline'
        }]
      }]
    },
    metrics: [{
      property: 'amount_in_home_currency',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'CRM_OBJECT',
    objectTypeId: '0-3',
    configType: 'AGGREGATION',
    dimensions: ['hubspot_team_id', 'hs_manual_forecast_category']
  },
  chartType: 'BAR',
  customized: true,
  resolveType: 'CONFIG',
  displayParams: {
    stacked: true,
    showTotals: true,
    dataColumns: ['amount_in_home_currency', 'dealstage', 'hs_manual_forecast_category', 'hs_forecast_amount', 'hs_projected_amount', 'hs_projected_amount_in_home_currency', 'hubspot_team_id'],
    customSeries: []
  },
  reportConfigs: {
    secondary: {
      filters: {
        teams: [],
        custom: [{
          value: 'currency',
          values: [],
          operator: 'EQ',
          property: 'hs_kpi_unit_type'
        }, {
          value: 'sales_quota',
          operator: 'EQ',
          property: 'hs_goal_type'
        }, {
          value: 'USD',
          operator: 'EQ',
          property: 'hs_goal_target_currency_code'
        }, {
          value: 0,
          operator: 'NEQ',
          property: 'hs_kpi_value'
        }, {
          values: ['teams'],
          operator: 'IN',
          property: 'hs_assignee_type'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'hs_pipeline_ids'
        }],
        owners: [],
        dateRange: {
          value: {
            date: null,
            endDate: '2024-12-31',
            rangeType: 'LAST_YEAR',
            startDate: '2024-01-01',
            rollingDays: null,
            rollingDates: null,
            entireCurrentUnit: true
          },
          property: 'hs_start_datetime',
          useFiscalYear: false
        }
      },
      metrics: [{
        property: 'hs_target_amount_in_home_currency',
        metricTypes: ['SUM'],
        percentiles: []
      }],
      dataType: 'CRM_OBJECT',
      configType: 'AGGREGATION',
      dimensions: ['hubspot_team_id'],
      processors: [],
      eventFunnel: null,
      objectTypeId: '0-74'
    }
  },
  visualization: {
    type: 'XY',
    style: {
      x: {
        left: {}
      },
      y: {
        bottom: {}
      },
      type: 'bar',
      colors: ['#fea58e', '#51d3d9', '#bda9ea', '#f5c78e', '#ea90b1', '#81c1fd', '#a4d398', '#c3705c', '#009ca2', '#8775b2', '#bb915b', '#b05c7d', '#468cc4', '#6b9a5b'],
      isMobile: false,
      dataLabels: false,
      showLegend: true,
      stackLabels: true,
      dataLabelFormat: 'Y'
    },
    layers: [{
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        stack: 'DEFAULT_STACK',
        stacking: true
      },
      color: {
        field: 'hs_manual_forecast_category',
        defined: {
          CLOSED: '#ea90b1',
          COMMIT: '#f5c78e',
          PIPELINE: '#51d3d9',
          BEST_CASE: '#bda9ea',
          '@@MISSING@@': '#fea58e'
        }
      },
      dataset: 'primary'
    }, {
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_target_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        type: 'tick',
        marker: {
          lineColor: '#516f90',
          lineWidth: 2
        },
        dashStyle: 'shortDash'
      },
      color: {
        default: '#516f90'
      },
      dataset: 'secondary'
    }]
  },
  editors: [{
    type: EDITOR_TYPES.DIMENSION,
    properties: ['hubspot_team_id', 'hubspot_owner_id']
  }, {
    type: EDITOR_TYPES.BREAKDOWN,
    properties: ['hs_manual_forecast_category']
  }, {
    type: EDITOR_TYPES.OVERTIME_TOTALS
  }]
};
export const QUOTA_ATTAINMENT_CONFIG = {
  name: 'Quota Attainment',
  config: {
    sort: [],
    filters: {
      teams: [],
      custom: [],
      owners: [],
      dateRange: {
        value: {
          endDate: '2024-12-31',
          rangeType: 'LAST_YEAR',
          startDate: '2024-01-01',
          entireCurrentUnit: true
        },
        property: 'closedate',
        useFiscalYear: false
      },
      filterGroups: [{
        filters: [{
          value: 'false',
          values: [],
          operator: 'EQ',
          property: 'hs_is_closed_lost'
        }, {
          values: ['default'],
          operator: 'IN',
          property: 'pipeline'
        }]
      }]
    },
    metrics: [{
      property: 'amount_in_home_currency',
      metricTypes: ['SUM'],
      percentiles: []
    }],
    dataType: 'DEALS',
    configType: 'AGGREGATION',
    dimensions: ['hubspot_team_id', 'hs_manual_forecast_category']
  },
  chartType: 'BAR',
  customized: true,
  resolveType: 'CONFIG',
  displayParams: {
    stacked: true,
    showTotals: true,
    dataColumns: ['amount_in_home_currency', 'dealstage', 'hs_manual_forecast_category', 'hs_forecast_amount', 'hs_projected_amount', 'hs_projected_amount_in_home_currency', 'hubspot_team_id'],
    customSeries: []
  },
  reportConfigs: {
    goalTarget: {
      filters: {
        teams: [],
        custom: [{
          value: 'currency',
          values: [],
          operator: 'EQ',
          property: 'hs_kpi_unit_type'
        }, {
          value: 'sales_quota',
          operator: 'EQ',
          property: 'hs_goal_type'
        }, {
          value: 'USD',
          operator: 'EQ',
          property: 'hs_goal_target_currency_code'
        }, {
          values: ['teams'],
          operator: 'IN',
          property: 'hs_assignee_type'
        }],
        owners: [],
        dateRange: {
          value: {
            endDate: '2024-12-31',
            rangeType: 'LAST_YEAR',
            startDate: '2024-01-01',
            entireCurrentUnit: true
          },
          property: 'hs_start_datetime',
          useFiscalYear: false
        }
      },
      metrics: [{
        property: 'hs_target_amount_in_home_currency',
        metricTypes: ['SUM'],
        percentiles: []
      }],
      dataType: 'CRM_OBJECT',
      configType: 'AGGREGATION',
      dimensions: ['hubspot_team_id'],
      processors: [],
      eventFunnel: null,
      objectTypeId: '0-74'
    },
    forecast: {
      filters: {
        teams: [],
        custom: [{
          values: ['default'],
          operator: 'IN',
          property: 'hs_deal_pipeline_id'
        }],
        owners: [],
        dateRange: {
          value: {
            endDate: '2024-12-31',
            rangeType: 'LAST_YEAR',
            startDate: '2024-01-01',
            entireCurrentUnit: true
          },
          property: 'hs_forecast_start_date',
          useFiscalYear: false
        }
      },
      metrics: [{
        property: 'hs_amount',
        metricTypes: ['SUM'],
        percentiles: []
      }],
      dataType: 'CRM_OBJECT',
      configType: 'AGGREGATION',
      dimensions: ['hubspot_team_id'],
      processors: [],
      eventFunnel: null,
      objectTypeId: '0-60'
    }
  },
  visualization: {
    type: 'XY',
    layers: [{
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        stack: 'DEFAULT_STACK',
        stacking: true
      },
      color: {
        field: 'hs_manual_forecast_category',
        defined: {
          CLOSED: '#ea90b1',
          COMMIT: '#f5c78e',
          PIPELINE: '#51d3d9',
          BEST_CASE: '#bda9ea',
          '@@MISSING@@': '#fea58e'
        }
      },
      dataset: 'primary'
    }, {
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_target_amount_in_home_currency'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        type: 'tick',
        marker: {
          lineColor: '#516f90',
          lineWidth: 2
        },
        dashStyle: 'shortDash'
      },
      color: {
        default: '#516f90'
      },
      dataset: 'goalTarget'
    }, {
      x: {
        type: 'linear',
        blend: 'left',
        field: 'SUM|hs_amount'
      },
      y: {
        type: 'category',
        blend: 'bottom',
        field: 'hubspot_team_id'
      },
      mark: {
        type: 'scatter',
        marker: {
          radius: 3.5,
          symbol: 'circle',
          fillColor: '#ffffff',
          lineColor: '#81c1fd',
          lineWidth: 2
        },
        stacking: false
      },
      color: {
        default: '#81c1fd'
      },
      dataset: 'forecast'
    }]
  }
};